import { render, staticRenderFns } from "./SampleData.vue?vue&type=template&id=3093787b&"
import script from "./SampleData.vue?vue&type=script&lang=js&"
export * from "./SampleData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports